{
  "title": "entities",
  "type": "array",
  "uniqueItems": true,
  "items" : {
    "title": "entity",
    "type": "object",
    "properties": {
      "id": {
        "description": "The unique identifier for an entity",
        "type": "integer",
        "minimum": 0
      },
      "internalId":{
        "description": "The internal id of an entity : used in eggs metadata for example",
        "type": "integer",
        "minimum": 0
      },
      "displayName": {
        "description": "The display name of an entity",
        "type": "string"
      },
      "name": {
        "description": "The name of an entity",
        "type": "string",
        "pattern": "\\S+"
      },
      "type": {
        "description": "The type of an entity",
        "type": "string"
      },
      "width": {
        "description": "The width of the entity",
        "type": [
          "number",
          "null"
        ]
      },
      "height": {
        "description": "The height of the entity",
        "type": [
          "number",
          "null"
        ]
      },
      "length": {
        "description": "The length of the entity",
        "type": [
          "number",
          "null"
        ]
      },
      "offset": {
        "description": "The offset of the entity",
        "type": [
          "number",
          "null"
        ]
      },
      "category": {
        "description": "The category of an entity : a semantic category",
        "type": "string"
      },
      "metadataKeys": {
        "description": "The pc metadata tags of an entity. (Naming is via mc code, with data_ and id_ prefixes stripped)",
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    },
    "required": [
      "id",
      "displayName",
      "name",
      "type",
      "width",
      "height"
    ],
    "additionalProperties": false
  }
}